// extracted by mini-css-extract-plugin
export default {"formContainer":"CreateOrder_formContainer__lqsRi","main":"CreateOrder_main__DDw+f","formItem":"CreateOrder_formItem__ntEbg","submitContainer":"CreateOrder_submitContainer__t-Ux0"};